import { getEnvUrl } from 'utils/core';

const AIRMEET_DUPLICATION_STATUS = {
    PENDING: 'PENDING',
    FAILED: 'FAILED',
};

export const AIRMEET_STATUS = {
    ONGOING: 'ONGOING',
    CREATED: 'CREATED',
    PAUSED: 'PAUSED',
    FINISHED: 'FINISHED',
    PRE_EVENT_ACCESS: 'PRE_EVENT_ACCESS',
    ...AIRMEET_DUPLICATION_STATUS,
};
export const CODE = 'code';
export const EXHIBITOR_CODE = 'exhibitorToken';
export const MAGIC_LINK_DETAILS = 'magicLinkDetails';
export const LIVE_DEMO_EVENT_ID = process.env.REACT_APP_LIVE_DEMO_EVENT;

// Env URLs
export const REACT_APP_SERVER_BASE_URL = getEnvUrl(
    process.env.REACT_APP_SERVER_BASE_URL
);
export const REACT_APP_API_BASE_URL = getEnvUrl(
    process.env.REACT_APP_API_BASE_URL
);
export const REACT_APP_BFF_BASE_URL = getEnvUrl(
    process.env.REACT_APP_BFF_BASE_URL
);
export const REACT_APP_PLATFORM_BASE_URL = getEnvUrl(
    process.env.REACT_APP_PLATFORM_BASE_URL
);
export const REACT_APP_ANALYTICS_BASE_URL = getEnvUrl(
    process.env.REACT_APP_ANALYTICS_BASE_URL
);
export const REACT_APP_OPS_BASE_URL = getEnvUrl(
    process.env.REACT_APP_OPS_BASE_URL
);
export const REACT_APP_INTERCEPTOR_ENDPOINT = getEnvUrl(
    process.env.REACT_APP_INTERCEPTOR_ENDPOINT
);
export const REACT_APP_AIRMEET_PROXY_SERVER_URL = getEnvUrl(
    process.env.REACT_APP_AIRMEET_PROXY_SERVER_URL
);
export const REACT_APP_CLOSED_CAPTIONS_SERVER = getEnvUrl(
    process.env.REACT_APP_CLOSED_CAPTIONS_SERVER
);
export const REACT_APP_NOTIFICATION_BASE_URL = getEnvUrl(
    process.env.REACT_APP_NOTIFICATION_BASE_URL
);
export const REACT_APP_INTERCEPTOR_BASE_URL = getEnvUrl(
    process.env.REACT_APP_INTERCEPTOR_BASE_URL
);
